<template>
  <form @submit.prevent="tierAction">
    <div class="mb-3">
      <label>Name</label>
      <input
          v-model="customer.name"
          name="name"
          type="text"
          class="form-control py-3"
          :class="{
            'is-invalid': v$.customer.name.$error,
          }"
      />
      <p
          v-for="error of v$.customer.name.$errors"
          :key="error.$uid"
          class="invalid-feedback"
      >
        {{error.$message}}
      </p>
    </div>
    <div class="mb-3">
      <label>Minimum Order Total</label>
      <input
          v-model="customer.minimumInvoiceTotal"
          name="name"
          type="number"
          class="form-control py-3"
          :class="{
            'is-invalid': v$.customer.minimumInvoiceTotal.$error,
          }"
      />
      <p
          v-for="error of v$.customer.minimumInvoiceTotal.$errors"
          :key="error.$uid"
          class="invalid-feedback"
      >
        {{error.$message}}
      </p>
    </div>
    <div class="mb-3">
      <label>Description</label>
      <textarea
          v-model="customer.description"
          class="form-control"
          :class="{
            'is-invalid': v$.customer.description.$error,
          }"
          rows="5"
      ></textarea>
      <p
          v-for="error of v$.customer.description.$errors"
          :key="error.$uid"
          class="invalid-feedback"
      >
        {{error.$message}}
      </p>
    </div>
    <div v-for="(error, index) in userSettingsErrors" :key="index" style="color: #D13704;">
      {{error.message}}
    </div>
    <div class="mt-3 align-middle">
      <b-button variant="primary" size="lg" class="py-3 h3" disabled v-if="userSettingsLoading">
        <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
        Loading
      </b-button>
      <b-button variant="primary" size="lg" class="py-3 h3 text-white" type="submit" v-else>
        {{ button_text }}
      </b-button>
    </div>
  </form>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import {required} from "@vuelidate/validators";
import {mapGetters} from "vuex";

export default {
name: "customer-tier-form",
  setup () {
    return { v$: useVuelidate() }
  },
  data(){
    return{
      customer: this.selected_tier
    }
  },
  props: {
    selected_tier: {
      type: Object,
      default () {
        return {
          name: "",
          minimumInvoiceTotal: 0,
          description: "",
        }
      }
    },
    button_text: {type: String}
  },
  computed: {
    ... mapGetters({
      userSettingsLoading: 'user/userSettingsLoading',
      userSettingsErrors: 'user/userSettingsErrors'
    }),
  },
  validations () {
    return {
      customer: {
        name: {required},
        minimumInvoiceTotal: {required},
        description: {required}
      }
    }
  },
  methods: {
    async tierAction(){
      const isFormCorrect = await this.v$.$validate()
      if (!isFormCorrect) {
        return
      }

      this.$emit('tierAction', this.customer)
      this.v$.$touch();
    }
  }
}
</script>

<style scoped>

</style>
